module.exports = __webpack_public_path__ + "img/diverse-workforces@2x.bdbfc879.webp";